import React from 'react';
import { cn } from '@/lib/utils';

/** Classes for an element `useDockMagnify` transforms: eased, and still under reduced motion. */
export const DOCK_GLYPH_CLASS = 'will-change-transform transition-transform duration-150 ease-out motion-reduce:transition-none';

/**
 * The part of a control that magnifies. Wrap the icon, not the button, so the
 * button's hover fill, active pill and layout stay put while the glyph grows.
 */
export function DockGlyph({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <span data-dock-glyph className={cn('relative inline-flex', DOCK_GLYPH_CLASS, className)}>
      {children}
    </span>
  );
}
